import React, { FC, MouseEvent } from "react";
import {
  RadioButton,
  TRadioButtonProps,
} from "../../../ActionsSelectors/RadioButton";
import CreditCardInfo from "../CreditCardInfo/CreditCardInfo";
import { Typography } from "../../../Fundamentals/Typography";
import { SvgIcon } from "../../../Icons";
import composeAddress from "../composeAddress";
import { TFormAddressData } from "../CreditCardForm.interface";
import { TCreditCardData } from "../CreditCardInfo/CreditCardInfo.interface";

export interface ICreditCardOption
  extends Pick<TRadioButtonProps, "name" | "checked" | "value" | "onChange"> {
  /** Credit card information */
  creditCard: TCreditCardData;
  /** Billing address structure */
  billingAddress: TFormAddressData;
  /** A callback for click on edit (pencil icon) */
  onEdit(event: MouseEvent<SVGAElement>): void;
}

const CreditCardOption: FC<ICreditCardOption> = ({
  creditCard,
  billingAddress,
  name,
  value,
  checked,
  onChange,
  onEdit,
}) => {
  const composedBillingAddress = composeAddress(billingAddress);
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label
      className="p-6 d-flex flex-nowrap bg-color-grey-200"
      data-testid="CreditCardOption"
    >
      <RadioButton
        className="form-check-input form-check-input--light me-5"
        name={name}
        checked={checked}
        value={value}
        onChange={onChange}
      />
      <div className="flex-grow-1">
        <CreditCardInfo classes={{ root: "mb-6" }} cardData={creditCard} />
        <div className="mb-6">
          <Typography
            variant="text-desc"
            classes={{ root: "mb-3 text-color-grey-700" }}
            as="div"
          >
            Billing address
          </Typography>
          <Typography
            variant="p-medium"
            classes={{ root: "text-color-blue" }}
            as="div"
          >
            {composedBillingAddress}
          </Typography>
        </div>
      </div>
      <div>
        <SvgIcon
          type="svg-icon"
          icon="EditIcon"
          classes={{ root: "cursor-pointer" }}
          data-testid="CreditCardOption__edit"
          onClickCapture={onEdit}
        />
      </div>
    </label>
  );
};

export default CreditCardOption;
